export default "__VITE_ASSET__d47f5e88__"